// src/components/DashBoard/FAQ.js
import React from 'react';
import { useTranslation } from 'react-i18next';

import './FAQ.css';

const FAQ = () => {
  const { t } = useTranslation(); // Hook para traducciones

  return (
    <div className="faq-wrapper">
    <div className="faq-container">
      <div className="faq-card card">
        <div className="title">
          <h5 className="fw-semibold py-1 mb-3">{t('faq')}</h5>
        </div>
        <div className="accordion">
          <div className="accordion-item">
            <div className="accordion-header">
              <button type="button" className="accordion-button collapsed" data-bs-toggle="collapse" data-bs-target="#question1">
                <i className="ph-question me-2"></i>
                {t('reveat')}
              </button>
            </div>
            <div id="question1" className="accordion-collapse collapse">
              <div className="accordion-body">
                <p className="mb-3">
                  {t('whatReveatDoes')}
                </p>
              </div>
            </div>
          </div>

          <div className="accordion-item">
            <div className="accordion-header">
              <button type="button" className="accordion-button collapsed" data-bs-toggle="collapse" data-bs-target="#question2">
                <i className="ph-question me-2"></i>
                {t('reveatBenefits')}
              </button>
            </div>
            <div id="question2" className="accordion-collapse collapse">
              <div className="accordion-body">
                <p className="mb-3">
                  {t('reveatBenefitsBody')}
                </p>
              </div>
            </div>
          </div>

          <div className="accordion-item">
            <div className="accordion-header">
              <button type="button" className="accordion-button collapsed" data-bs-toggle="collapse" data-bs-target="#question3">
                <i className="ph-question me-2"></i>
                {t('reveatPrice')}
              </button>
            </div>
            <div id="question3" className="accordion-collapse collapse">
              <div className="accordion-body">
                <p className="mb-3">
                {t('reveatPriceBody')}
                </p>
              </div>
            </div>
          </div>

          <div className="accordion-item">
            <div className="accordion-header">
              <button type="button" className="accordion-button collapsed" data-bs-toggle="collapse" data-bs-target="#question4">
                <i className="ph-question me-2"></i>
                {t('reveatContact')}
              </button>
            </div>
            <div id="question4" className="accordion-collapse collapse">
              <div className="accordion-body">
                <p className="mb-3">
                  {t('reveatContactBody')}
                </p>
              </div>
            </div>
          </div>

          <div className="accordion-item">
            <div className="accordion-header">
              <button type="button" className="accordion-button collapsed" data-bs-toggle="collapse" data-bs-target="#question5">
                <i className="ph-question me-2"></i>
                {t('reveatData')}
              </button>
            </div>
            <div id="question5" className="accordion-collapse collapse">
              <div className="accordion-body">
                <p className="mb-3">
                {t('reveatDataBody')}
                </p>
              </div>
            </div>
          </div>

          <div className="accordion-item">
            <div className="accordion-header">
              <button type="button" className="accordion-button collapsed" data-bs-toggle="collapse" data-bs-target="#question6">
                <i className="ph-question me-2"></i>
                {t('reveatMyBusiness')}
              </button>
            </div>
            <div id="question6" className="accordion-collapse collapse">
              <div className="accordion-body">
                <p className="mb-3">
                {t('reveatMyBusinessBody')}
                </p>
              </div>
            </div>
          </div>

          <div className="accordion-item">
            <div className="accordion-header">
              <button type="button" className="accordion-button collapsed" data-bs-toggle="collapse" data-bs-target="#question7">
                <i className="ph-question me-2"></i>
                {t('reveatComparison')}
              </button>
            </div>
            <div id="question7" className="accordion-collapse collapse">
              <div className="accordion-body">
                <p className="mb-3">
                  {t('reveatComparisonBody')}
                </p>
              </div>
            </div>
          </div>

          <div className="accordion-item">
            <div className="accordion-header">
              <button type="button" className="accordion-button collapsed" data-bs-toggle="collapse" data-bs-target="#question8">
                <i className="ph-question me-2"></i>
                {t('reveatReports')}
              </button>
            </div>
            <div id="question8" className="accordion-collapse collapse">
              <div className="accordion-body">
                <p className="mb-3">
                  {t('reveatReportsBody')}
                </p>
              </div>
            </div>
          </div>

          <div className="accordion-item">
            <div className="accordion-header">
              <button type="button" className="accordion-button collapsed" data-bs-toggle="collapse" data-bs-target="#question9">
                <i className="ph-question me-2"></i>
                {t('reveatDiscover')}
              </button>
            </div>
            <div id="question9" className="accordion-collapse collapse">
              <div className="accordion-body">
                <p className="mb-3">
                  {t('reveatDiscoverBody')}
                </p>
              </div>
            </div>
          </div>

          {/* Preguntas adicionales sugeridas */}
          <div className="accordion-item">
            <div className="accordion-header">
              <button type="button" className="accordion-button collapsed" data-bs-toggle="collapse" data-bs-target="#question10">
                <i className="ph-question me-2"></i>
                {t('reveatSecurity')}
              </button>
            </div>
            <div id="question10" className="accordion-collapse collapse">
              <div className="accordion-body">
                <p className="mb-3">
                  {t('reveatSecurityBody')}
                </p>
              </div>
            </div>
          </div>

          <div className="accordion-item">
            <div className="accordion-header">
              <button type="button" className="accordion-button collapsed" data-bs-toggle="collapse" data-bs-target="#question11">
                <i className="ph-question me-2"></i>
                {t('reveatTechSupport')}
              </button>
            </div>
            <div id="question11" className="accordion-collapse collapse">
              <div className="accordion-body">
                <p className="mb-3">
                  {t('reveatTechSupportBody')}
                </p>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
    </div>
  );
};

export default FAQ;
